import React, { useState, useCallback, useEffect, useRef } from "react";
import { Link, RouteComponentProps } from "react-router-dom";
import { toast } from "react-toastify";

import { Button } from "semantic-ui-react";
import TemplateTable from "../../components/TemplateTable";
import { ITableAppRender } from "../../components/TableApp";

import { ISearch } from "../../components/Search";

import errors from "../../Utils/ExtractErrors";
import { ISearchResponse } from "../../interfaces";
import { IFields } from "../../components/Search/FilterBuilder";
import AgentsRepository, { IAgentListModel } from "../../Repositories/AgentsRepository";

interface ILocationState {
    status: string;
    month: number;
}

const ConferenteAgents: React.FC<RouteComponentProps<any, any, ILocationState>> = ({ location }) => {

    const [list, setList] = useState<IAgentListModel[]>([]);
    const [loading, setLoading] = useState<boolean>(false);

    const refSearch = useRef<ISearch>({ searchString: "", type: "simples" });
    const refRecordsByPage = useRef<number>(20);
    const refPageNumber = useRef<string | number | undefined>(1);
    const refTotalRecords = useRef<number>(0);
    const refTotalPages = useRef<number>(1);

    const onChangeRecords = (value: number) => {
        refRecordsByPage.current = value;
        load();
    }

    const onPageChange = (pageNumber: string | number | undefined) => {
        refPageNumber.current = pageNumber;
        load();
    }

    const tableRender: ITableAppRender[] = [
        {
            header: "Nome",
            content: (a: IAgentListModel) => a.nome,
            width: 8
        },
        {
            header: "Cidade",
            content: (a: IAgentListModel) => a.cidade,
            width: 6
        },
    ];

    const load = useCallback(async () => {

        setLoading(true);
        try {
            let response: ISearchResponse<IAgentListModel>;

            if (refSearch.current.type === "simples") {
                response = await AgentsRepository.ListToConference({
                    searchRequest: {
                        search: refSearch.current.searchString,
                        pageNumber: refPageNumber.current,
                        recordsByPage: refRecordsByPage.current
                    },
                    month: location.state.month,
                    status: location.state.status
                });
            } else {
                response = await AgentsRepository.ListToConference({
                    searchRequest: {
                        filter: refSearch.current.searchString,
                        pageNumber: refPageNumber.current,
                        recordsByPage: refRecordsByPage.current
                    },
                    month: location.state.month,
                    status: location.state.status
                });
            }

            refTotalRecords.current = response.totalRecords;
            refTotalPages.current = response.totalPages;

            setList(response.list);
        } catch (err) {
            if (err.response.status === 401) {
                window.location.href = "/";
            }

            const error = errors.getAllErrors(err.response.data);

            if (error !== undefined)
                toast(error, { position: "top-center", type: "error" });
        }
        setLoading(false);
    }, [location.state.month, location.state.status]);

    const onSearch = ({ searchString, type }: ISearch) => {
        refSearch.current.searchString = searchString;
        refSearch.current.type = type;

        load();
    }

    const conferenceButton = ({ id, representante }: { id: string; representante: string; }) => (
        <Button
            key={`conferencekit_buttonconference_${id}`}
            as={Link}
            icon="calendar check"
            color="blue"
            to={{
                pathname: `/conferenceagent/${id}`,
                state: {
                    representante,
                    month: location.state.month,
                    status: location.state.status
                }
            }}
        />
    );

    useEffect(() => { load() }, [load]);

    const fields: IFields[] = [
        // { label: "G. Regional", name: "Pedido.GerenteRegional.Nome", type: "string", roles: ["Admin", "Operador"] },
        // { label: "G. Setor", name: "Pedido.GerenteSetor.Nome", type: "string", roles: ["Admin", "Operador", "GerenteR"] },
        // { label: "Representante", name: "Pedido.Representante.Nome", type: "string", roles: ["Admin", "Operador", "GerenteR", "GerenteS"] },
        // { label: "Revendedor", name: "Revendedor.Nome", type: "string", roles: ["Admin", "Operador", "GerenteR", "GerenteS", "Representante"] },
        // { label: "Acerto", name: "Pedido.Acerto", type: "date", roles: ["Admin", "Operador", "GerenteR", "GerenteS", "Representante"] },
        // { label: "Número", name: "Numero", type: "number", roles: ["Admin", "Operador", "GerenteR", "GerenteS", "Representante"] }
    ];

    return (
        <TemplateTable
            title="Conferência"
            icon="clipboard check"
            tableList={list}
            tableRender={tableRender}
            tableActions={(data: IAgentListModel, index: number) => {
                return ([conferenceButton({
                    id: data.id || "",
                    representante: data.nome
                })])
            }}
            searchPlaceHolder="Nome"
            onSearch={onSearch}
            filterFields={fields}
            tableLoading={loading}
            tableOnChangeRecords={onChangeRecords}
            tablePagination={{
                currentPage: refPageNumber.current,
                totalRecords: refTotalRecords.current,
                totalPages: refTotalPages.current,
                onPageChange: onPageChange
            }}
        />
    );
};

export default ConferenteAgents;
